import ScrollMagic from 'scrollmagic';

const animationBetweenSections = () => {

	const toggleOtherSections = ( actualSection, allSections, toggleFunction ) => {
		Array.from( allSections )
			.filter( currentSection => currentSection.id !== actualSection.id )
			.forEach( currentSection => {
				// console.log( actualSection.id + ' enter Forward ' + currentSection.id + ' hides' );
				toggleFunction( currentSection );
				toggleTitle( currentSection, toggleFunction );
			});
	};

	const toggleTitle = ( section, toggleFunction ) => {
		const $prevElement = $( section ).prev( '.gsection' );
		if ( $prevElement.length ) {
			toggleFunction( $prevElement.get( 0 ) );
		}
	};

	const showSection = ( section ) => {
		section.classList.add( 'show-form-section' );
		section.classList.remove( 'hide-form-section' );
	};

	const hideSection = ( section ) => {
		section.classList.add( 'hide-form-section' );
		section.classList.remove( 'show-form-section' );
	};

	// Uncomment to debug animation
	const setSectionAnimation = ( controller, section, sections ) => {
		new ScrollMagic.Scene({
			triggerElement: section,
			triggerHook: .75,
			duration: section.clientHeight,
		})
		.addTo( controller )
		.on( 'enter leave', ( event ) => {
			section.classList.remove( 'form-section__hidden' );
			// console.log( section.id );
			// console.log( event.type );
			// console.log( event.target.controller().info( 'scrollDirection' ) );
			if ( event.target.controller().info( 'scrollDirection' ) === 'FORWARD' ) {
				if ( event.type === 'enter' ) {
					showSection( section );
					toggleTitle( section, showSection );
					toggleOtherSections( section, sections, hideSection );
				}
			} else if ( event.target.controller().info( 'scrollDirection' ) === 'REVERSE' ) {
				if ( event.type === 'leave' ) {
					// console.log( section.id + ' hides - Leave Reverse' );
					hideSection( section );
					toggleTitle( section, hideSection );
					toggleOtherSections( section, sections, showSection );
				} else {
					// console.log( section.id + ' shows - Enter Reverse' );
					showSection( section );
					toggleTitle( section, showSection );
					toggleOtherSections( section, sections, hideSection );
				}
			}
		});
	};

	const getVisibleSections = () => {
		const sections = [];
		$( '.gform_page:visible .gform_item_wrapper_begin' ).each( function getElements() {
			sections.push( $( this ).get( 0 ) );
		});
		// Add the Doctor section
		$( '.gform_page:visible .doctors' ).each( function getElements() {
			sections.push( $( this ).get( 0 ) );
		});

		return sections;
	};

	const main = () => {
		const controller = new ScrollMagic.Controller();
		const sections = getVisibleSections();

		sections.forEach( section => {
			setSectionAnimation( controller, section, sections );
		});
	};

	main();
};

export default animationBetweenSections;
